import React, { useEffect, useState } from 'react';
import styles from './taskHeader.css';
import { Button } from '@momentum-ui/react';
import PropTypes from 'prop-types';
import { i18n } from '../../utils/GadgetUtils';
import WrapupButtonWithDialog from './wrapupbuttonwithdialog/index';
import PhonepadButton from './phonepadbutton/index';
import TaskTitle from './tasktitle/index';
import "@momentum-ui/web-components";
import AlertModal from './alertmodal';

const TaskHeader = (props) => {
    console.log(':: TaskHeader props ', props);

    const WRAP_UP_MODES = window.finesse.restservices.User.WrapUpMode;
    const deploymentType = window.gadgets.Prefs().getString("deploymentType");
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [buttonClick, setbuttonClick] = useState(false);
    const [continueWithoutSave, setContinueWithoutSave] = useState(false);


    useEffect(() => {
        console.log(':: taskHeader task changed. updated task is- ', props);
        props.task.updateTaskInLS && props.task.updateTaskInLS();
     }, [props.task]);

    const handleEndButtonClick = (e) => {
        e.preventDefault();
        if(props.unsavedChanges === false || continueWithoutSave === true){
            setContinueWithoutSave(false);            
            if (props.userData.isWrapUpRequired) {
                props.task.myParticipant.actions['WRAP_UP'].actionListener();
            } else {
                props.task.myParticipant.actions['CLOSE'].actionListener(e); // passing e to actionListener to reset the flag in useMediasetup and make appropriate request
            }
        }
        else{
            setbuttonClick(true);
        }
	}

    useEffect(() => {
        if(continueWithoutSave === true){
            if (props.userData.isWrapUpRequired) {
                props.task.myParticipant.actions['WRAP_UP'].actionListener();
            } else {
                props.task.myParticipant.actions['CLOSE'].actionListener('CLOSE'); // passing e to actionListener to reset the flag in useMediasetup and make appropriate request
            }
            setContinueWithoutSave(false);
        }
    }, [continueWithoutSave])

    const handleCloseButtonClick = (e) => {
        e.preventDefault();
        clearTimeout(props.task.wrapUpTimeout);
        props.task.myParticipant.actions['CLOSE'].actionListener(e); // passing e to actionListener to reset the flag in useMediasetup and make appropriate request
	}

    // TODO
    const phonepadActionCallback = (number) => {
        props.task.myParticipant.actions['TRANSFER'].actionListener(number);
    }

    /*
	 * Returns Overlay CSS which disables the agent state to be changed.
	 * For UCCE - Aligned with Required with wrap up data
	 * FOR UCCX - Aligned with Required
	 */
	const enableForceWrapUp = () => {
        const wrapUpAppliedOrNotAvailable = 
            props.task.endOperationSuccess
            && isWrapUpAppliedOrNotAvaiable();
		if (deploymentType === 'UCCE') {
			return props.userData.wrapUpOnIncoming === WRAP_UP_MODES.REQUIRED_WITH_WRAP_UP_DATA &&
				props.task.endOperationSuccess
                && !wrapUpAppliedOrNotAvailable;
		}
        return props.task.endOperationSuccess && !wrapUpAppliedOrNotAvailable;
	}

    const isWrapUpApplied = () => {
        if ((props.task.endOperationSuccess && props.userData.isWrapUpRequired)) {
            return deploymentType === 'UCCE' ? props.task.selectedWrapupReason !== undefined : props.task.wrapUpItems !== undefined;
        }
    }

    /**
     *
     * @param {*} state
     * This returns the call object for which the state is wrap up and in the same call object
     * we need to check that wrap up reason is applied or not.Also , If there are no wrap up reasons configured
     * we send true so that force wrap up not apply
     */
    const isWrapUpAppliedOrNotAvaiable = () => {
        const flag = props.wrapUpReasons && props.wrapUpReasons.options.length > 0
            ? isWrapUpApplied() : true;
        return flag;
    }

    const isForceWrapUp = () => {
        const result = enableForceWrapUp() && window.finesse.container.Config.forceWrapUp === 'true';
        return result;
    }

    const enableForceWrapUpForTransfer = () => {
        let flag = false;
        if (props.userData.isWrapUpRequired) {
            flag = deploymentType === 'UCCE' ? props.task.selectedWrapupReason !== undefined : props.task.wrapUpItems !== undefined;
        }
        const wrapUpAppliedOrNotAvailable = props.wrapUpReasons && props.wrapUpReasons.options.length > 0 ? flag : true;
		if (deploymentType === 'UCCE') {
			return props.userData.wrapUpOnIncoming === WRAP_UP_MODES.REQUIRED_WITH_WRAP_UP_DATA && !wrapUpAppliedOrNotAvailable
                && window.finesse.container.Config.forceWrapUp === 'true';
		}
        return !wrapUpAppliedOrNotAvailable && window.finesse.container.Config.forceWrapUp === 'true';
    }

    const countDown = window.finesse.container.Config.wrapUpCountDown === 'true';

    const showWrapUpTimer = window.finesse.container.Config.showWrapUpTimer === 'true';

    useEffect(() => {
        console.log(':: taskHeader [props.task.selectedWrapupReason] changed. Updated task is- ', props.task);
        if (props.task.selectedWrapupReason) {
            props.task.myParticipant && props.task.myParticipant.actions['APPLY_WRAP_UP'] && props.task.myParticipant.actions['APPLY_WRAP_UP'].actionListener(props.task.selectedWrapupReason);
        }
    }, [props.task.selectedWrapupReason]);

    const getStartTimeValue = () => {
        if (countDown) {
            const value = Math.round(Number(props.userData.wrapUpTimer) - ((window.finesse.utilities.Utilities.currentServerTimeMillis() - (props.task.stateChangetimeMs || window.finesse.utilities.Utilities.currentServerTimeMillis()))/1000));
            console.log(':: taskHeader getStartTimeValue count_DOWN value- ', value);
            return value;
        } else {
            const value = Math.round((window.finesse.utilities.Utilities.currentServerTimeMillis() - (props.task.stateChangetimeMs || window.finesse.utilities.Utilities.currentServerTimeMillis()))/1000);
            console.log(':: taskHeader getStartTimeValue count_UP value- ', value, typeof(value));
            return value;
        }

    }

    const getScriptSelectors = () => {
        if (props.scriptSelectors && props.scriptSelectors.options) {
            const mrdScriptSelectors = props.scriptSelectors.options.filter(scriptSelector => scriptSelector.MrdID === props.task.mrdID);
            return { options : mrdScriptSelectors };
        }
        return props.scriptSelectors;
    }

     useEffect(() => {
        setUnsavedChanges(props.unsavedChanges);
     },[props.unsavedChanges])


    return (
        <div>
            <div className={styles.header}>
                <TaskTitle name={props.task.title} mediaType={props.task.mediaType} 
                    startTime={(new Date().getTime() / 1000) - props.task.timeStamp}
                    id={props.task.taskId} isInterrupted={props.task.isInterrupted}/>
                <div style={{display: "flex"}}>
                    {!props.task.endOperationSuccess && 
                    <PhonepadButton
                        endOperationInProgress={props.task.endOperationInProgress}
                        disableTransfer={props.task.disableTransfer || props.task.isInterrupted}
                        phonepadActionCallback={phonepadActionCallback}
                        transferInProgress={props.task.transferInProgress}
                        scriptSelectors={getScriptSelectors()}
                        transferError={props.task.transferError}
                        transferErrorCode={props.task.transferErrorCode}
                        key={"transfer"}
                        isForceWrapUp={enableForceWrapUpForTransfer()}
                        id={`transfer-${props.task.taskId}`}
                        isDTMF={false} 
                        unsavedChanges={unsavedChanges} 
                        />}
                    {(!props.task.endOperationSuccess || (props.task.endOperationSuccess && props.userData.isWrapUpRequired)) &&
                    <WrapupButtonWithDialog 
                        displayTimer={(props.task.endOperationSuccess && props.userData.isWrapUpRequired && showWrapUpTimer)}
                        wrapUpReasons={props.wrapUpReasons}
                        countDown={Number(props.userData.wrapUpTimer) > 0 && countDown
                            && props.task.endOperationSuccess}
                        startTime={getStartTimeValue()}
                        selectedWrapupReason={props.task.selectedWrapupReason}
                        wrapupApplyCallback={props.task.myParticipant && props.task.myParticipant.actions['APPLY_WRAP_UP'] && props.task.myParticipant.actions['APPLY_WRAP_UP'].actionListener}
                        wrapUpApplyError={props.task.wrapUpApplyError}
                        id={props.task.taskId}
                        stateChangetimeMs={props.task.stateChangetimeMs}
                        isInterrupted = {props.task.isInterrupted}
                        isDisabled={(props.task.endOperationInProgress || props.task.transferInProgress || props.task.isInterrupted)} />}
                    {!props.task.endOperationSuccess && <Button
                        className={`${styles.taskHeaderButton} ${styles.endButton}`}
                        children={[
                            <md-icon key="end-button" name='icon-clear_16' style={{ marginRight: "8px", marginTop: "4px",
                                display: `${props.task.endOperationInProgress ? "none" : "block"}` }}/>,
                            <md-spinner key="end-button-loading" size='16' class={styles.endButtonSpinner}
                                style={{ marginRight: "8px",
                                display: `${props.task.endOperationInProgress ? "block" : "none"}` }}/>,
                            <span key="end-label">{i18n.getMsg('gadget.imi.operation.DROP')}</span>

                        ]}
                        ariaLabel={i18n.getMsg('gadget.imi.operation.end.arialabel')} tabIndex="0"
                        id={"button-end"}
                        disabled={props.task.transferInProgress || props.task.isInterrupted}
                        size={40}
                        onClick={handleEndButtonClick} />}
                    {(props.task.endOperationSuccess && props.userData.isWrapUpRequired) && 
                    <Button
                        className={`${styles.taskHeaderButton} ${styles.closeButton}`}
                        children={[
                            <span key="close-label">{i18n.getMsg('gadget.imi.operation.CLOSE')}</span>
                        ]}
                        ariaLabel={i18n.getMsg('gadget.imi.operation.close.arialabel')} tabIndex="0"
                        id={"button-close"}
                        disabled={isForceWrapUp() || props.task.isInterrupted}
                        size={40} color="white"
                        onClick={handleCloseButtonClick} />}
                </div>
            </div>
            <md-alert-banner id="failure-alert-banner" 
                {...((props.task.endOperationError || props.task.closeOperationError) ? {show: true} : {})} closable type='error'
                message={i18n.getMsg('gadget.imi.header.end.failure')} />
            {buttonClick && <AlertModal unSavedChanges={props.unsavedChanges} ButtonClick={buttonClick} setButtonClick={setbuttonClick} continueWithoutSave={continueWithoutSave} setContinueWithoutSave={setContinueWithoutSave} /> 
            }
        </div>
    );
}

TaskHeader.propTypes = {
    task: PropTypes.object,
    wrapUpReasons: PropTypes.shape({
        options: PropTypes.array
    }),
    userData: PropTypes.object
};

export default TaskHeader;
